<template>
  <div class="goods_index">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="width_center_1200">
      <div class="goods_info_top_mbx">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/home/machine' }">{{ lang.machine_location }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ vemInfo.vemName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="machine-content">
        <div v-loading="loading" class="machine-info">
          <el-image :src="vemInfo.vemimg" lazy></el-image>
          <div class="info">
            <div class="head">
              <div class="name">{{ vemInfo.vemName }}</div>
              <div class="location">
                <svg-icon iconClass="location" />
                {{ vemInfo.distance }}{{ vemInfo.distanceunit }}
              </div>
            </div>
            <div class="address-box">
              <div class="address">{{ vemInfo.vemaddress }}</div>
              <!-- <div class="btn">{{ lang.location }}</div> -->
            </div>
          </div>
          <div class="action-cart" @click="tabIndex = 1">
            <div class="cart-icon">
              <svg-icon iconClass="cart_white" />
              <div v-if="cartList.length > 0" class="shop_car_dot">{{ cartList.length }}</div>
            </div>
            {{ lang.cart }}
          </div>
          <div v-if="tabIndex === 1" class="action-cart back" @click="tabIndex = 0">
            <div class="cart-icon">
              <svg-icon iconClass="back" />
            </div>
            {{ lang.back }}
          </div>
        </div>
        <goods-tab v-if="tabIndex === 0"></goods-tab>
        <cart-tab v-else :list="cartList"></cart-tab>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import GoodsTab from './goods.vue'
import CartTab from './cart.vue'
import { getvendingmachinedetail } from '@/api/vendingmachine'
import { getcartlist } from '@/api/cart'
export default {
  components: {
    ShopTop,
    ShopFoot,
    GoodsTab,
    CartTab
  },
  data() {
    return {
      vemInfo: {},
      cartList: [],
      loading: true,
      tabIndex: 0
    }
  },
  computed: {
    lang() {
      return this.$t('machine')
    },
    ...mapGetters(['isLogin', 'location']),
    vemId() {
      return this.$route.query.vemId
    }
  },
  async created() {
    this.getMachineInfo()
    if (this.isLogin) {
      this.getCartList()
    }
  },
  methods: {
    // 获取自助机信息
    getMachineInfo() {
      getvendingmachinedetail({
        lat: this.location.lat,
        lng: this.location.lng,
        vemId: this.vemId
      }).then(({ data }) => {
        this.loading = false
        this.vemInfo = data
      })
    },
    // 获取自助机购物车
    getCartList() {
      getcartlist({
        vemId: this.vemId
      }).then(({ data }) => {
        this.cartList = data.map((item) => {
          return {
            ...item,
            checked: false
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.goods_info_top_mbx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
}
.machine-content {
  margin-bottom: 30px;
  .machine-info {
    float: left;
  }
  .cont {
    float: left;
    width: 885px;
    margin-left: 15px;
  }
}
.machine-info {
  background: #fff;
  padding-bottom: 15px;
  width: 300px;
  .el-image {
    display: flex;
    width: 300px;
    height: 168px;
  }
  .info {
    width: 260px;
    padding: 20px;
    // border-bottom: 1px solid #eeeeee;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      .name {
        font-size: 14px;
        color: #4f4f4f;
      }
      .location {
        font-size: 12px;
        color: #aaaaaa;
      }
    }
    .address-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      .address {
        color: #aaaaaa;
      }
      .btn {
        color: #0061b5;
      }
    }
  }
  .action-cart {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 270px;
    height: 38px;
    line-height: 38px;
    background: #ec9221;
    border: 1px solid #ec9221;
    border-radius: 12px;
    margin: 15px auto 0;
    box-sizing: border-box;
    font-size: 14px;
    color: #fff;
    border-radius: 12px;
    &.back {
      background: #fff;
      color: #4f4f4f;
    }
    .cart-icon {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 20px;
    }
    .svg-icon {
      width: 24px;
      height: 24px;
    }
    a:hover {
      color: #ec9221;
    }
    .shop_car_dot {
      position: absolute;
      top: -2px;
      left: 12px;
      text-align: center;
      line-height: 16px;
      background: #ff0000;
      min-width: 20px;
      font-size: 12px;
      color: #fff;
      border-radius: 10px;
    }
  }
}
</style>